<template>
  <div style="background: #fafafa">
    <div class="blbg">
        <img src="../../../static/icons/icon_yygh_yycg.png" alt="">
        <p>预约成功</p>
        <div class="bgline"></div>
        <div class="qrbox font-85">
            <p>长按下方二维码<br>
            关注肖瘤医生并查看挂号信息</p>
            <div class="dochead">
                <img :src="orderData.avatar" alt="">
            </div>
            <p class="docname">
                {{orderData.zname}}
            </p>
            <img class="qrcode" :src="apiUrl+'/api/wap/visit/qrcodeurl?id='+$route.query.orderid" alt="">
        </div>
    </div>
    <div class="btmlogo">
        <img src="../../../static/icons/yygh_logo2.png" alt="">
    </div>
  </div>
</template>
<script>
import http from "../../request/http";
export default {
  name: "guahaoSuccess",
  data() {
    return {
      orderData:{
        
      },
      qrcodeUrl:'',
      apiUrl:process.env.API_ROOT
    };
  },
  components: {},
  computed: {},
  mounted() {
    this.codeDetail();
    console.log(process.env.API_ROOT)
  },
  methods: {
    codeDetail(){
      http.post('/api/wap/visit/orderqrcode',{
        id: this.$route.query.orderid
      }).then(res=>{
        this.orderData = res.data;
      })
    }
  },
};
</script>
<style scoped>
@import 'guahao.css';
</style>



// WEBPACK FOOTER //
// src/pages/guahao/success.vue